module.exports = __webpack_public_path__ + "img/SaveResources.b0cf0f3.svg";